export default "__VITE_ASSET__6F9eSFEN__"